module.exports = __webpack_public_path__ + "static/media/about_armenia_7.3c4e1b64.jpg";